import axios from 'axios';

const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

// 🟢 Using the clean instance without the 15-second timeout!
const cleanAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true, 
});

export const videoConnectivityAPI = {
  initiateVideoSession: async (data: { expertCode: string, categoryId: number | null, intakeData?: any }) => {
    // Hardcoding sessionType as 'video'
    const response = await cleanAxios.post('/api/session/initiate', {
      ...data,
      sessionType: 'video'
    });
    return response.data;
  },

  leaveQueue: async (expertCode: string) => {
    const response = await cleanAxios.post('/api/session/leave-queue', { expertCode });
    return response.data;
  }
};